import ApiClient from "@/lib/api-client"

export default {
  namespaced: true,

  state: {
    submissions: {}, // taskId => submission
    fetchedSubmissions: {}
  },

  mutations: {
    // Replace the whole map so consumers reading state.submissions[taskId]
    // for an unknown key still re-evaluate when the key is later added.
    // Vue 2 can't reactively track reads on non-existent keys, but a reference
    // change on the parent object will re-trigger any computed that accessed it.
    setSubmission(state, { taskId, submission }) {
      state.submissions = { ...state.submissions, [taskId]: submission }
    },

    setFetchedSubmission(state, taskId) {
      state.fetchedSubmissions = { ...state.fetchedSubmissions, [taskId]: true }
    }
  },

  getters: {
    submissionForTask: state => taskId => state.submissions[taskId] || null,
    hasFetchedSubmission: state => taskId => !!state.fetchedSubmissions[taskId]
  },

  actions: {
    async fetchTaskSubmission({ commit, state }, taskId) {
      if (!taskId) return null
      if (state.fetchedSubmissions[taskId]) {
        return state.submissions[taskId] || null
      }

      const res = await ApiClient.get(`/tasks/${taskId}/submission`)
      const submission = res.data?.task_submission || null

      commit("setSubmission", { taskId, submission })
      commit("setFetchedSubmission", taskId)

      return submission
    },

    async createTaskSubmission({ commit }, { taskId, value }) {
      const res = await ApiClient.post(`/tasks/${taskId}/submissions`, {
        value
      })
      const submission = res.data?.task_submission
      commit("setSubmission", { taskId, submission })
      commit("setFetchedSubmission", taskId)
      return submission
    }
  }
}
